/* Pagination Helprs */
import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from './AssetHelpers'
import {ColumnDescription} from 'react-bootstrap-table-next'

export const sortCaret = (order?: string) => {
  if (!order)
    return (
      <span className='svg-icon svg-icon-sm svg-icon-primary ml-1 svg-icon-sort'>
        <SVG src={toAbsoluteUrl('/media/svg/icons/Shopping/Sort1.svg')} />
      </span>
    )
  else if (order === 'asc')
    return (
      <span className='svg-icon svg-icon-sm svg-icon-primary ml-1'>
        <SVG src={toAbsoluteUrl('/media/svg/icons/Navigation/Up-2.svg')} />
      </span>
    )
  else if (order === 'desc')
    return (
      <span className='svg-icon svg-icon-sm svg-icon-primary ml-1'>
        <SVG src={toAbsoluteUrl('/media/svg/icons/Navigation/Down-2.svg')} />
      </span>
    )
  return null
}

export const headerSortingClasses = (
  _column: ColumnDescription,
  sortOrder: 'asc' | 'desc',
  _isLastSorting: boolean,
  _colIndex: number
) => (sortOrder === 'asc' || sortOrder === 'desc' ? 'sortable-active' : '')
